import { ROUTER } from '@/shared/config'
import { useRouterContext } from '@/shared/context'
import { buildEffectiveMenu, flattenLeaves } from '@/shared/lib/menu'
import { storage } from '@/shared/lib/storage'
import { queryClient } from '@/shared/queries'
import { changeAuthorization, setListMenu, setListTabs, setUserInfo } from '@/shared/redux'
import PageLoading from '@/shared/ui/page-loading'
import UiButton from '@/shared/ui/ui-button'
import UiResult from '@/shared/ui/ui-result'
import { MainLayout } from '@/widgets/layout-admin'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'

function AdminRoutes() {
  const { setRouterBefore } = useRouterContext()

  const { listMenu } = useSelector((state: any) => state?.appGlobal)
  const isLogin = storage.getAuthToken()
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Lối thoát khi 403 còn token: cùng trình tự với handleLogout của MenuUser.
  const handleLogout = () => {
    storage.clearAuthSession()
    dispatch(setUserInfo({}))
    dispatch(setListTabs([]))
    dispatch(setListMenu(null))
    dispatch(changeAuthorization(false))
    queryClient.clear()
    navigate(ROUTER.LOGIN, { replace: true })
  }

  useEffect(() => {
    if (!isLogin) setRouterBefore(`${location.pathname}${location?.search}`)
  }, [isLogin, location, setRouterBefore])

  // MỘT nguồn gate duy nhất: buildEffectiveMenu (đồng bộ giữa sidebar, trang mặc định sau login).
  // Đếm trên LEAF, không đếm node gốc — nhóm cha luôn tồn tại nên đếm nó thì nhánh 403 không
  // bao giờ chạy. `listMenu === null` là "đang tải" (chưa fetch xong), không phải "0 quyền" —
  // tách riêng để hiện skeleton thay vì 403 oan trong lúc chờ. Mảng rỗng thật sự vẫn 403 như cũ.
  const isMenuLoading = listMenu === null
  const allowedLeafCount = useMemo(
    () => (isMenuLoading ? 0 : flattenLeaves(buildEffectiveMenu(listMenu)).length),
    [isMenuLoading, listMenu]
  )

  return isLogin ? (
    <div style={{ maxWidth: '100%', maxHeight: '100vh', overflowX: 'hidden' }}>
      {isMenuLoading ? (
        <PageLoading variant="private" />
      ) : allowedLeafCount > 0 ? (
        <MainLayout type="isAdmin">
          <Outlet />
        </MainLayout>
      ) : (
        <UiResult
          status="403"
          title="403 Erorr Permission"
          subTitle="Xin lỗi, Bạn không có quyền truy cập trang web."
          extra={
            <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
              <NavLink to={ROUTER.DEFAULT}>
                <UiButton className="btn-hover-shadow">Quay lại trang chủ</UiButton>
              </NavLink>
              <UiButton className="btn-hover-shadow" onClick={handleLogout}>
                Đăng xuất / đăng nhập lại
              </UiButton>
            </div>
          }
        />
      )}
    </div>
  ) : (
    <Navigate to={ROUTER.HOME} />
  )
}

export default AdminRoutes
